// An agency applying to a job with one of its consultants: whether the candidate must still consent,
// and the consultant's profile listing, both from the agency's own link to that consultant.
// The server still decides the application's status; this is what the agency asks for.
export const agencyApplyWithConsultant = ({ link }) => {
  return {
    applyStatus: link?.status === 'accepted' ? 'pending' : 'candidate consent pending',
    consultantListingId: link?.listingId || null,
  };
};

// Shown when an agency tries to apply with a consultant but none has accepted its link.
export const NO_ACCEPTED_CONSULTANT =
  'None of your consultants has accepted your link yet, so there is no one to apply with.';
